<mat-expansion-panel class="mat-elevation-z0">
  <mat-expansion-panel-header>
    <mat-panel-title [class.isRequired]="modifierGroupStructure.required">
      <span [class.isDifferent]="isNameDifferent()">{{initValues.name}}</span>&nbsp;
      <span *ngIf="getTypeName()">{{getTypeName()}}</span>
      <span [class.isDifferent]="isModifierGroupMinDifferent()">min: {{this.initValues.min}}</span>&nbsp;
      <span [class.isDifferent]="isModifierGroupMaxDifferent()">max: {{this.initValues.max}}</span>&nbsp;
      <span *ngIf="initValues.freeQuantity || isModifierGroupFreeQuantityDifferent()"
            [class.isDifferent]="isModifierGroupFreeQuantityDifferent()">free: {{this.initValues.freeQuantity}}</span>&nbsp;
      <span [class.isDifferent]="isModifierGroupRequiredDifferent()">{{this.initValues.required ? 'required' : ''}}</span>
      <span [class.isDifferent]="isModifierGroupChildModifiersHaveMinMaxRestrictionsDifferent()">
        {{isModifierGroupChildModifiersHaveMinMaxRestrictionsDifferent() ? 'grRestr' : ''}}
      </span>
      <span [class.isDifferent]="isModifierGroupHideImagesDifferent()">
        {{isModifierGroupHideImagesDifferent() ? 'hide imgs' : ''}}
      </span>
      <span [class.isDifferent]="modifierGroupStructure.isHidden">{{this.initValues.isHidden ? 'hidden' : ''}}</span>
    </mat-panel-title>
    <mat-panel-description>modifier quantity: {{ modifierGroupStructure.modifierProducts.length }}</mat-panel-description>
    <mat-icon
      *ngIf="!isBeingSaveProcessed && allowOverrides"
      (click)="editModifierGroup($event)"
      class="edit-icon"
      color="primary"
      matTooltip="{{ iconTooltip }}"
      matTooltipPosition="above">{{ isEditingMode ? 'save' : 'edit' }}
    </mat-icon>
    <mat-icon *ngIf="isBeingSaveProcessed">data_usage</mat-icon>
  </mat-expansion-panel-header>
  <section *ngIf="isEditingMode">
    <header class="header">
      <div class="col" style="flex: 3">Name
        <mat-icon *ngIf="isNameDifferent()" matSuffix mat-icon-button aria-label="Clear"
                  matTooltip="{{originalModifierGroup.name ?? 'undefined'}}" (click)="clearName()"
                  class="restore">
          restore
        </mat-icon>
      </div>
      <div *ngIf="roleMembership && roleMembership.isManager" class="col">Min</div>
      <div *ngIf="roleMembership && roleMembership.isManager" class="col">Max</div>
      <div *ngIf="roleMembership && roleMembership.isManager" class="col">Free</div>
      <div *ngIf="roleMembership && roleMembership.isManager" class="col">Required</div>
      <div *ngIf="roleMembership && roleMembership.isManager" class="col">GrRestr</div>
      <div *ngIf="roleMembership && roleMembership.isManager" class="col">Hidden</div>
      <div *ngIf="roleMembership && roleMembership.isManager" class="col">Hide Imgs</div>
    </header>
    <div>
      <div class="row">
        <div class="col" style="flex: 3">
          <input [(ngModel)]="modifierGroupName"
                 class="modifier-input input-name"
                 [class.isDifferent]="isNameDifferent()"
                 type="text"
                 (blur)="onChangeInformationMessage()">
          <div *ngFor="let lang of nameTranslationKeys">
            <mat-label [class.isDifferent]="isNameTranslationDifferent(lang)">
              {{lang}}
            </mat-label>
            <mat-icon *ngIf="isNameTranslationDifferent(lang)" matSuffix mat-icon-button aria-label="Clear"
                      matTooltip="{{originalModifierGroup.nameTranslations[lang] ?? 'undefined'}}" (click)="clearNameTranslation(lang)"
                      class="restore">
              restore
            </mat-icon>
            <br>
            <input value = "{{nameTranslations[lang]}}" (input) = "changeModifierGroupNameTranslations($event, lang)"
                   class="modifier-input input-name">
          </div>
        </div>
        <div *ngIf="roleMembership && roleMembership.isManager" class="col">
          <input [(ngModel)]="modifierGroupMin"
                 class="modifier-input input-number"
                 [class.isDifferent]="isModifierGroupMinInputDifferent()"
                 min="0"
                 type="number"
                 (blur)="onChangeInformationMessage()">
        </div>
        <div *ngIf="roleMembership && roleMembership.isManager" class="col">
          <input [(ngModel)]="modifierGroupMax"
                 class="modifier-input input-number"
                 [class.isDifferent]="isModifierGroupMaxInputDifferent()"
                 min="0"
                 type="number"
                 (blur)="onChangeInformationMessage()">
        </div>
        <div *ngIf="roleMembership && roleMembership.isManager" class="col">
          <input [(ngModel)]="modifierGroupFreeQuantity"
                 class="modifier-input input-number"
                 [class.isDifferent]="isModifierGroupFreeQuantityInputDifferent()"
                 min="0"
                 type="number"
                 (blur)="onChangeInformationMessage()">
        </div>
        <div *ngIf="roleMembership && roleMembership.isManager" class="col">
          <mat-checkbox [(ngModel)]="modifierGroupRequired"
                 type="checkbox"
                 (blur)="onChangeInformationMessage()">
          </mat-checkbox>
        </div>
        <div *ngIf="roleMembership && roleMembership.isManager" class="col">
          <mat-checkbox [(ngModel)]="childModifiersHaveMinMaxRestrictions"
                 type="checkbox"
                 (blur)="onChangeInformationMessage()">
          </mat-checkbox>
        </div>
        <div *ngIf="true" class="col">
          <mat-checkbox [(ngModel)]="isHidden"
                        (ngModelChange)="onClickIsHidden()"
                 type="checkbox"
                 (blur)="onChangeInformationMessage()">
            </mat-checkbox>
        </div>
        <div *ngIf="true" class="col">
          <mat-checkbox [(ngModel)]="hideImages"
                 type="checkbox"
                 (blur)="onChangeInformationMessage()">
            </mat-checkbox>
        </div>
      </div>
      <div class="row">
        <div class="col" id="modifierGroupType">
          <mat-form-field>
            <mat-select *ngIf="modifierGroupTypesDictionary" [value]="modifierGroupTypeId">
              <mat-option [value]="" (click)="onMgTypePicked('')">No type</mat-option>
              <mat-option *ngFor="let mgType of modifierGroupTypes" [value]="mgType.id"
              (click)="onMgTypePicked(mgType.id)">{{mgType.typeName}}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-icon (click)="openModifierGroupTypeModal(true)">add</mat-icon>
          <mat-icon (click)="openModifierGroupTypeModal(false)">edit</mat-icon>
          <mat-icon (click)="onRemoveMgType(modifierGroupTypeId)" >delete</mat-icon>
        </div>
      </div>
    </div>
  </section>
  <section>
    <header class="header">
      <div class="col" style="flex: 3">Name</div>
      <div class="col" *ngIf="modifierGroupStructure.childModifiersHaveMinMaxRestrictions">Min</div>
      <div class="col">Default</div>
      <div class="col" *ngIf="modifierGroupStructure.childModifiersHaveMinMaxRestrictions">Max</div>
      <div class="col">Price</div>
      <div class="col">Hidden</div>
      <div class="col"></div>
    </header>

    <app-edit-modifier
      *ngFor="let modifierProduct of sortedModifiers; trackBy: trackByFn; let i = index;"
      [originalModifierGroup]="this.originalModifierGroupStructure"
      [modifierGroup]="this.modifierGroupStructure"
      [(editedModifierId)] = "this.editedModifierId"
      [currency]="currency"
      [modifierProduct]="modifierProduct"
      [originalModifierProduct]="getOriginalModifierProduct(i)"
      [dictionaryProducts]="dictionaryProducts"
      [originalDictionaryProducts]="originalDictionaryProducts"
      [overridePositionsMap]="overridePositionsMap"
      [menuSections]="menuSections"
      [menuSectionId]="menuSectionId"
      [currentOrganization]="currentOrganization"
      [productId]="productId"
      [saveForMenuSections]="saveForMenuSections"
      [saveForAll]="saveForAll"
      [saveForAllCombo]="saveForAllCombo"
      [isHidden]="childrenIshidden[i]"
      [index]="i"
      (changeInformationMessageEvent)="changeInformationMessageEvent.emit($event)"
      [saveForAllProductsInComboGroup]="this.saveForAllProductsInComboGroup"
      [comboGroupStructure]="this.comboGroupStructure"
      (changeIsHidden)="onChildrenChangeIsHidden($event)"
      [allowOverrides]="allowOverrides"
    ></app-edit-modifier>
  </section>

</mat-expansion-panel>
